import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/Relatorio";

/**
 * Classe de gerenciamento de chamadas da API de relatórios
 *
 * @class
 */
export default class CustomReportApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe ReportApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * Resgata um modelo de relatório personalizado
   * @param codRelatorioCustom - Código do modelo de relatório personalizado
   * @returns modelo de relatório personalizado
   */
  get(codRelatorioCustom?: number) {
    return this.api<any>(`${controller}/GetRelatorioCustom`, {
      method: "GET",
      params: {
        codRelatorioCustom: codRelatorioCustom ?? 0,
      },
    });
  }

  /**
   * Realiza o cadastro de um relatório customizado
   * @param descricao - Descrição do modelo de relatório
   * @param relatorio - Dados do relatório em string
   * @returns boolean
   */
  post(descricao: string, relatorio: string) {
    return this.api<boolean>(`${controller}/PostRelatorioCustom`, {
      method: "POST",
      body: {
        DESCRICAO: descricao,
        RELATORIO: relatorio,
      },
    });
  }

  /**
   * Realiza o cadastro de um relatório customizado
   * @param codRelatorioCustom - Código do modelo de relatório personalizado
   * @param descricao - Descrição do modelo de relatório
   * @param relatorio - Dados do relatório em string
   * @returns boolean
   */
  update(codRelatorioCustom: number, descricao: string, relatorio: string) {
    return this.api<boolean>(`${controller}/PostRelatorioCustom`, {
      method: "POST",
      body: {
        CODRELATORIOCUSTOM: codRelatorioCustom,
        DESCRICAO: descricao,
        RELATORIO: relatorio,
      },
    });
  }

  /**
   * Realiza a remoção de um modelo de relatório personalizado do banco
   * @param codRelatorioCustom - Código do modelo de relatório personalizado
   * @returns boolean
   */
  delete(codRelatorioCustom: number) {
    return this.api<boolean>(`${controller}/DeleteRelatorioCustom`, {
      method: "DELETE",
      params: { codRelatorioCustom },
    });
  }

  /**
   * Realiza a busca dos dados de acordo com o relatório construído
   * @param relatorioCustom - String das informações do relatório personalizado
   * @returns dados relatório personalizado
   */
  getData(relatorioCustom: RequestParams) {
    return this.api<CustomReportResult>(
      `${controller}/GetDadosRelatorioCustom`,
      {
        method: "GET",
        params: {
          relatorioCustom: JSON.stringify(relatorioCustom),
        },
      },
    );
  }

  /**
   * Realiza a busca pelos valos possíveis do filtro escolhido
   * @param tabela - Tabela principal do filtro
   * @param pk - PrimaryKey da tabela principal do filtro
   * @param descricao - Coluna de descrição do filtro
   * @returns valores possíveis para seleção no filtro
   */
  listFilterValues(tabela: string, pk: string, descricao: string) {
    return this.api<any>(`${controller}/GetValoresFiltroRelatorioCustom`, {
      method: "GET",
      params: {
        tabela,
        descricao,
        pk,
      },
    });
  }
}
